<form
  class="new-password__form"
  [formGroup]="formGroup"
  (ngSubmit)="onSubmit()"
>
  <h1 class="new-password__title">Nova Senha</h1>
  <hr class="w-25 mb-4" />
  <p class="new-password__sub-title">Insira a nova senha</p>

  <mat-form-field class="w-100">
    <mat-label>Nova Senha</mat-label>
    <input type="password" matInput formControlName="senha" />
    <mat-error *ngIf="formGroup.controls.senha.hasError('required')">
      Este campo é obrigatório
    </mat-error>
    <mat-error *ngIf="formGroup.controls.senha.hasError('invalid')">
      {{ formGroup.controls.senha.getError("invalid") }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Confirmação Nova Senha</mat-label>
    <input type="password" matInput formControlName="confirmeSenha" />
    <mat-error *ngIf="formGroup.controls.confirmeSenha.hasError('required')">
      Este campo é obrigatório
    </mat-error>
    <mat-error
      *ngIf="formGroup.controls.confirmeSenha.hasError('differentPass')"
    >
      As senhas são diferentes
    </mat-error>
  </mat-form-field>

  <button class="w-100" mat-flat-button color="primary" type="submit">
    <span>Salvar</span>
  </button>

  <section class="new-password__actions">
    <a routerLink="/entrar" class="default-hyper-link">
      Lembrou a senha? Entrar
    </a>
  </section>
</form>
